import Pagination from '@material-ui/lab/Pagination';
import React, { useEffect, useState } from 'react';

import { getDateFormat } from '../../_helpers/useful-functions';
import ReportGridTable from '../../components/report-grid-table';
import ReportTable from '../../components/report-table';
import Spinner from '../../components/ui/spinner';
import { useAppDispatch, useAppSelector } from '../../store';
import { getMomentReportsGropuTitleGrid, setGridPageIndex } from '../../store/features/moments-reports/momentReportsSlice';
import FeedCardContainer from './FeedCardContainer';
import FilterSection from './filterSection';

const ReportFeed = (): any => {
    const { dasboardFeed, page, gridTableGroupTitle, groupTitleGridTable, reportFilter } = useAppSelector(state => state.momentReports);
    const { words } = useAppSelector(state => state.localization);
    const [PaginationPage, setPaginationPage] = useState(1);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (gridTableGroupTitle?.type) {
            setPaginationPage(1);
        }
    }, [gridTableGroupTitle?.type]);

    useEffect(() => {
        setPaginationPage(groupTitleGridTable?.pageIndex + 1)
    }, [groupTitleGridTable])


    const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
        setPaginationPage(value);
        dispatch(setGridPageIndex(value));
        dispatch(
            getMomentReportsGropuTitleGrid({
                startDate: getDateFormat({ date_: reportFilter?.startDate }),
                endDate: getDateFormat({ date_: reportFilter?.endDate }),
                serviceUrl: gridTableGroupTitle?.serviceUrl,
                companyIdList: reportFilter?.companyIdList,
                type: gridTableGroupTitle?.type,
                pageSize: 50,
                pageIndex: value - 1,
            }),
        );
    };

    return (
        <div className="col-02">
            <FilterSection />
            {groupTitleGridTable?.hasNoData && <p className="f-no-data">{words && words['WEB.anyResultFounded']}</p>}

            {((dasboardFeed?.loading && page.subPage === 'dashboard-feed') ||
                (groupTitleGridTable?.loading && (page.subPage === 'notifications-grid' || page.subPage === 'groupTitle-grid'))) && (
                    <Spinner type="01" />
                )}

            {!dasboardFeed?.loading &&
                page.subPage === 'dashboard-feed' &&
                dasboardFeed?.items?.map((item, index) => (
                    <FeedCardContainer key={'dashboard-feed-card-container-' + index} name={item?.name} details={item?.details} />
                ))}
            {page?.pageMenuType === 1 && !groupTitleGridTable?.loading &&
                <div className='d-flex mb-2'>
                    {groupTitleGridTable?.buttonList?.map((button: any) =>
                        <div className="micro-card-07" key={button.name}>
                            <div className="card-body c-item-07">
                                {button.name}: {button.count}
                            </div>
                        </div>
                    )}
                </div>
            }
            {!gridTableGroupTitle?.loading && page.subPage === 'notifications-grid' && <ReportTable />}
            {!gridTableGroupTitle?.loading && page.subPage === 'groupTitle-grid' && <ReportGridTable />}


            <div className="pagination-wrapper">
                {(page.subPage === 'notifications-grid' || page.subPage === 'groupTitle-grid') &&
                    !groupTitleGridTable?.loading &&
                    groupTitleGridTable?.totalCount > 50 && (
                        <Pagination count={groupTitleGridTable?.totalPages} page={PaginationPage} onChange={handleChangePage} shape="rounded" />
                    )}
            </div>
        </div>
    );
};

export default ReportFeed;
